import Controller from './application_controller'
const INTERVAL_MS = 60_000

/**
 * Global connection state controller.
 * Simplified: dispatch `connection:restored` when network is online
 * or when we detect process suspension and navigator is online.
 */
export default class extends Controller {
  static targets = ['notice']
  staleTimer = null
  lastTickAt = Date.now()

  connect() {
    // On online: fire restored and toggle notice
    this.addEventListener(window, 'online', () => this.online())

    // Offline notice
    this.addEventListener(window, 'offline', () => this.toggleNotice())

    // On visibility back to visible: check for suspension
    this.addEventListener(document, 'visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.windowBecameVisible()
      }
    })

    // Periodic check to detect system sleep/suspension
    this.staleTimer = setInterval(() => this.checkSuspendedProcess(), INTERVAL_MS)

    // Initial state
    this.toggleNotice()
  }

  disconnect() {
    if (this.staleTimer) clearInterval(this.staleTimer)
    super.disconnect()
  }

  online() {
    this.toggleNotice()
    this.dispatch('restored', { prefix: "connection" })
  }

  windowBecameVisible() {
    this.toggleNotice()
    this.checkSuspendedProcess()
  }

  checkSuspendedProcess() {
    const now = Date.now()
    const gap = now - this.lastTickAt
    // Consider process suspended if gap >= 2 * INTERVAL
    this.lastTickAt = now
    if (navigator.onLine && gap >= 2 * INTERVAL_MS) this.online()
  }

  toggleNotice() {
    if (!this.hasNoticeTarget) return

    if (navigator.onLine) {
      this.noticeTarget.close()
    } else {
      this.noticeTarget.show()
    }
  }
}
